module.exports = __webpack_public_path__ + "img/6.909a428d.png";